// src/games/Sudoku/Game/Board/index.tsx
import React from 'react';

import type { iBox } from '../../../../interfaces/sudoku';
import { useSudoku } from '../../SudokuContext';
import { Square } from './Square';
import { Container } from './styles';

interface BoardProps {
  bigSquare: iBox;
  values: string[];
}

export const Board: React.FC<BoardProps> = ({ bigSquare, values }: BoardProps) => {
  const { width, matrix } = useSudoku();
  const boxWidth = Number(bigSquare['box-width']);
  const boxHeight = Number(bigSquare['box-height']);

  return (
    <Container>
      {matrix.map((row, x) => (
        <div key={x} className="row">
          {row.map((cell, y) => (
            <Square
              key={x * width + y}
              x={x}
              y={y}
              values={values}
              value={cell.value}
              isHint={cell.isHint}
              isRevealed={!!cell.revelada}
              boxWidth={boxWidth}
              boxHeight={boxHeight}
              isSquareSolution={cell.solution}
            />
          ))}
        </div>
      ))}
    </Container>
  );
};
